module.exports = __webpack_public_path__ + "pic2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic2.jpg
// module id = 1579
// module chunks = 4